import React, { useState } from 'react';
import { Button, Link, Stack } from '@hover/blueprint';
import { ArrowButton, DownloadAppModal } from '@hover/shared-components';
import { URLS } from '../../constants';

const HeroButtons: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleModal = () => setIsOpen(!isOpen);
  return (
    <Stack
      w={{ base: '100%', tablet: 'auto' }}
      direction={{ base: 'column', tablet: 'row' }}
      spacing={{ base: 400, tablet: 500 }}
    >
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Button
        onClick={toggleModal}
        size="large"
        w={{ base: '100%', tablet: 'auto' }}
        textTransform="uppercase"
      >
        start free trial
      </Button>
      <ArrowButton
        as={Link}
        href={URLS.howToMeasureRoof.chatWithUs}
        variant="minimal"
        w={{ base: '100%', tablet: 'auto' }}
        sx={{
          // TODO(buttons): remove when we remove padding in Blueprint
          div: { pl: 0, pr: 50 },
        }}
      >
        Chat with us
      </ArrowButton>
    </Stack>
  );
};

export default HeroButtons;
